export enum VC_FG_BOMTYPE {
  InternalAssembly = 'Internal Assembly',
  CutAssembly = 'Cut Assembly',
  ThirdPartyAssembly = '3rd Party Assembly',
  ThirdPartyValueAdd = '3rd Party Value-Add',
  PriceBundle = 'Price Bundle',
  ServiceBundle = 'Service Bundle',
  RepeatableValueAdd = 'Repeatable Value-Add',
}

export enum ORDER_STATUS {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
}

export enum OPERATION_TYPE {
  Add = 'ADD_FG',
  Edit = 'EDIT_FG',
}

type Nullable<T> = T | null;

interface AuditFields {
  Created?: string | null;
  Modified?: string | null;
}

interface Pricing {
  unitCost?: string | number | null;
  unitPrice?: string | number | null;
  extendedCost?: string | number | null;
  extendedPrice?: string | number | null;
  gpPercentage?: string | number | null;
  gpAmount?: string | number | null;
}

interface InventoryInfo {
  invAvlBackOrderQty?: number | null;
  invAvlAllocatedQty?: number | null;
  invAvlReleasedQty?: number | null;
  invAvlPicking?: number | null;
  invAvlPicked?: number | null;
  invAvlPacked?: number | null;
  invAvlShipped?: number | null;
  invAvlInvoiced?: number | null;
  invAvlLocQty?: number | null;
  invAvlOnOrderQty?: number | null;
  invAvlProcessed?: number | null;
  invAvlEstimatedAllocDate?: string | null;
  invAvlEstimatedDeliveryDate?: string | null;
  invAvlEstimatedShipDate?: string | null;
}

interface SupplierInfo {
  supplierSite?: string | null;
  supplierQuoteNumber?: string | null;
  supplierQuoteCost?: string | number | null;
  supplierQuoteValidFrom?: string | null;
  supplierQuoteValidTill?: string | null;
  supplierQuoteUOM?: string | number | null;
}
interface Notes {
  noteSalesLineInternal?: string | null;
  noteCustomerOrderAndInvoices?: string | null;
  noteWarehouseInternalPackerLine?: string | null;
  noteBuyerInternal?: string | null;
  noteSupplierPOLine?: string | null;
  noteSupplierPOHeader?: string | null;
  noteSupplierPOShipping?: string | null;
  noteEDIComments?: string | null;
  noteVasWorkInstruction?: string | null;
}
interface BaseCPQ extends Pricing, InventoryInfo, SupplierInfo, Notes {
  salesOrderLineNumber?: string | number | null;
  saleOrderLineRefNumber?: string | null;
  parentSalesOrderLineNumber?: number | null;
  bomLevel?: number;
  transactablePartNumber?: string | null;
  shipType?: string | null;
  shipLocation?: string | null;
  quantity?: string | number | null;
  tax?: string | number | null;

  isManualPOCost: boolean;
  isManualUnitPrice: boolean;

  earliestAcceptDate?: string | null;
  requiredOnsiteDate?: string | null;
  customerLineNumber?: string | null;
  transferFromShipLocation?: string | null;

  fgBomEditAllowed: boolean;
  linkedWorkInstructionID?: string | null;
  soWorkInstructionURL?: string | null;
  fgWorkInstructionURL?: string | null;
  fgLeadTimeInDays?: string | number | null;
  fgWorkOrderRelease?: string | null;
  fgCutAssemblyRequired: boolean;
  fgOspSite?: string | null;
  fgOspShipTo?: string | null;

  buyerReviewRequired: boolean;
  lineStatus?: string | null;

  productInfo: string;
  pricingInfo: string;
  inventoryInfo: string;
  shipLocationShipType?: string | null;
}
export interface vcFGHeader {
  FinishedGoodId: string | null;
  ParentFinishedGoodId: string | null;
  IsTPart?: boolean;
  FGPartNumber: string | null;
  Description: string | null;

  Version: number;
  TransactiblePartNumber: string | null;
  BOMType: string;
  Status: string;

  Quantity: number | null;
  Cost: string | number | null;
  Price: string | number | null;
  AverageCost: string | number | null;

  GPPercentage: string | number | null;

  ProjectId?: string | null;

  OpsApprovalObtained: boolean;
  BOMEditAllowed: boolean;

  ShipType: string | null;
  PartType: string | null;

  WorkInstructionId: string | null;
  WorkInstructionName: string | null;

  FGLeadTimeInDays: number | null;
  CutAssembly: boolean;

  OSPSiteId: string | null;
  OSPShipToId: string | null;

  WorkOrderRelease: string | null;
  UOM: number | null;

  ShipLocationIds: string[];
  FinishedGoodDocuments: FGDocument[];
  OrgJson?: string | null;
  shipLocationShipType?: string | null;
  TaxonomyId?: string | null;
  PartJson?: string | null;
  TaskTypeId?: string | null;
  TaskTypeName?: string | null;
  TaskTypeCode?: string | null;
}

export interface vcFGHeaderCPQ extends BaseCPQ {
  shipSelection?: string | null;
  projectId?: string | null;
}

export interface BomLineNumbering {
  salesOrderLineNumber: number;
  parentSalesOrderLineNumber: number | null;
  bomLevel: number;
  parentSaleOrderLineRefNumber?: string | null;
}

interface BaseComponent {
  FinishedGoodLineItemId?: string | null;
  FinishedGoodId?: string | null;
  ParentFinishedGoodId?: string | null;
  ParentFinishedGoodLineItemId?: string | null;
  LineNumber?: number | null;

  PartNumber?: string | null;
  MFRPartNumber?: string | null;
  ManufacturerId?: string | null;
  ManufacturerName?: string | null;

  Description?: string | null;
  Quantity?: number | null;

  ShipType?: number | null;
  ShipLocationId?: string | null;
  ShipLocation?: string | null;

  InventoryType?: number | null;
  FgResInventory?: number | null;
  PartType?: number | null;
  ItemType?: string | null;

  SupplierSiteId?: string | null;
  SupplierSiteName?: string | null;

  UOM?: number | null;

  CustomerPartNumber?: string | null;
  TaxonomyId?: string | null;
  TaxonomyL1?: string | null;
  TaxonomyL1Name?: string | null;
  TaxonomyL2?: string | null;
  TaxonomyL2Name?: string | null;
  TaxonomyL3?: string | null;
  TaxonomyL3Name?: string | null;
  TaxonomyL4Name?: string | null;

  IsTPart?: boolean;
  PartJson?: string | null;

  FinishedGoodLineItemDocuments?: FGDocument[];
  children?: any[];
}

export interface TaxonomyLevels {
  taxonomyCode1: string | null;
  taxonomyName1: string | null;
  taxonomyCode2: string | null;
  taxonomyName2: string | null;
  taxonomyCode3: string | null;
  taxonomyName3: string | null;
  taxonomyCode4: string | null;
  taxonomyName4: string | null;
}

export interface SyntheticPartSearchRow extends Partial<TaxonomyLevels> {
  partNumber: string | null;
  partDescription: string | null;
  mfgPartNumber: string | null;
  manufacturerName: string | null;
  manufacturerCode: string | null;
  uom: number | null;
  partType: string | null;
  shipType: string | number | null;
  shipLocation: string | null;
  quantity: number | null;
  lineReference: string | null;
}

export interface SupplierContact {
  ContactId?: string | null;
  ContactName?: string | null;
  Email?: string | null;
  PhoneNumber?: string | null;
  IsPrimaryContact?: boolean;
}

export interface SupplierPoInfo {
  FOB?: string | null;
  // The type-code EnumValue backing FOB's description text — CPQ's submit payload wants both
  // fobCode and fobDescription, but FreightTerms/ShipMethod are plain LOV text on both sides.
  FOBCode?: string | null;
  FreightTerms?: string | null;
  ShipMethod?: string | null;
  FreightAccountNumber?: string | null;
  FreightAddress?: string | null;
  UrgentBuy?: boolean;
  CCSalesOnPO?: boolean;
  SendEDI?: boolean;
  IsEdiEnabled?: boolean;
  POPrepaymentRequired?: boolean;
  RevisedPromiseShipDate?: string | null;
  Contacts?: SupplierContact[];
  ContactId?: string | null;
  ContactName?: string | null;
  Email?: string | null;
  PhoneNumber?: string | null;
  AddContactToSupplierMaster?: boolean;
}

// TODO: confirm exact TypeCodeDescriptions `Entity` keys with backend — placeholders for now,
// following the same cached `type_code_descriptions` lookup pattern as `FinishedGoodLineItem.ShipType`
// (see vc-resolver.ts getFGlineItemShipTypes / vc-container.ts getTypeCodeDescriptions).
export const PO_FREIGHT_TERMS_ENTITY_KEY = 'SupplierPurchasingAttribute.FreightTerms';
export const PO_FOB_ENTITY_KEY = 'SupplierPurchasingAttribute.FOB';
export const PO_SHIP_METHOD_ENTITY_KEY = 'SupplierPurchasingAttribute.ShipMethod';

export interface vcFGComponent extends BaseComponent, Pricing, AuditFields {
  SupplierQuoteNumber?: string | null;
  SupplierQuoteValidTillDate?: string | null;
  BM?: string | number | null;
  GP?: string | number | null;
  SupplierPOInfo?: SupplierPoInfo | null;
  // Local "SupplierSiteId::ShipLocation" key recorded at the last fetch/save, so moreInfoVcRow()
  // can tell a still-valid cache apart from one made stale by a Supplier Site/Ship Location change.
  SupplierPOInfoFetchKey?: string | null;

  QuotedCost?: string | number | null;
  QuotedUOM?: number | null;
  QuotedEffectiveDate?: string | null;

  //required?
  Id?: string | null;
  SupplierCode?: string | null;
  CustomerPart?: string | null;
  SupplierQuote?: string | null;
  UnitCost?: string | number | null;
  UnitPrice?: string | number | null;
  ExtendedCost?: string | number | null;
  ExtendedPrice?: string | number | null;
  AverageCost?: string | number | null;
  ExtendedAverageCost?: string | number | null;
  MDMShipType?: string | null | number;
  AllocatedQuantity?: string | number | null;
  AvailableQuantity?: string | number | null;
  OnOrderQuantity?: string | number | null;
  BackOrderQuantity?: string | number | null;
  rowType?: string | null;
  randomNumber?: number | null;
  orderQuantity?: string | number | null;
  orderExtCost?: string | number | null;
  orderExtPrice?: string | number | null;
  PartStatus?: string | null;
  OrgJson?: string | null;
  InventoryJson?: string | null;
  shipLocationShipType?: string | null;
  TransferFromShipLocation?: string | null;
  InventorySegment?: string | null;
  InventorySegmentType?: string | null;
  StageGroupNumber?: any;
  StageDependencies?: any[];
  TaskTypeId?: string | null;
  TaskTypeName?: string | null;
  TaskTypeCode?: string | null;
  LBRPartTypeTaskAttributes?: Record<string, any> | null;
}

export interface StageGroup {
  StageGroupNumber: number;
  StageGroupName: string | null;
  StageDependenciesNames: string | null;
  children: vcFGComponent[];
}

export interface TaskDetail {
  stageGroupId: number | null;
  stageSequence: number | null;
  stageDependencies: any[] | null;
  taskType: string | null;
  taskAttributes: Record<string, any> | null;
}

export interface vcFGComponentCPQ extends BaseCPQ {
  componentShipTo?: string | null;
  parentSaleOrderLineRefNumber?: string | null;

  componentAdditionalCost?: string | number | null;
  componentAdditionalPrice?: string | number | null;

  kitConfigQty?: string | number | null;
  kitFulfilmentType?: string | null;
  kitFulfilmentTypeFormattedValue?: string | null;

  extCost?: string | number | null;
  extPrice?: string | number | null;
  fgTaskDetail?: TaskDetail | null;
}

export interface FGDocument {
  DocumentId: string;
  DocumentName?: string | null;
  DocumentURL: string;
  DocumentType: string;
  DocumentSize?: string | number | null;
}

export interface TypeCode {
  Description: string;
  DisplayOrder: number;
  Entity: string;
  EnumValue: number;
  TypeCodeId: number;
  // Short letter code (e.g. "CPT" for FOB "Carriage Paid To") — only FOB's submit payload to CPQ
  // needs this alongside its Description; other lookups (FreightTerms/ShipMethod) pass Description
  // text only.
  Code?: string | null;
}

export interface OrgAttributeRequestItem {
  PartNumber: string;
  ShipLocation: string | null;
  IsConfigurator?: boolean;
}

export interface OrgAttributeResponseItem {
  PartNumber: string;
  ShippingLocation?: string | null;
  StockNonStock?: string | null;
  LeadTime?: number | null;
  VelocityCode?: string | null;
  SupplierSite?: string | null;
  AbcClassification?: string | null;
  BuyerCode?: string | null;
  ReplenishmentMethod?: string | null;
  OrgJson?: string | null;
}
